module.exports = __webpack_public_path__ + "img/Germany.325493d5.png";